import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertDialogComponent } from './alert-dialog.component';
import { CustomMaterialModule } from '@sk/custom-material';
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
  declarations: [AlertDialogComponent],
  imports: [
    CommonModule,
    CustomMaterialModule,
    FlexLayoutModule
  ],
  providers: [],
  entryComponents: [AlertDialogComponent],
  exports: [AlertDialogComponent]
})
export class AlertDialogModule {
}
